<template>
  <div class="room-type-form">
    <b-card>
      <template #header>
        <h2 class="mb-0">{{ isEdit ? $t('room_types.edit_title') : $t('room_types.create_title') }}</h2>
      </template>
      <b-form @submit.prevent="handleSubmit" :validated="validated" novalidate>


        <b-form-group :label="$t('room_types.form.hotel_label')" label-for="hotel_id" :state="!hasError('hotel_id')"
          :invalid-feedback="getError('hotel_id')">

          <treeselect id="hotel_id" v-model="formFields.hotel_id" :options="hotelOptions" :normalizer="normalizer"
            :state="!hasError('hotel_id')" :class="hasError('hotel_id') ? 'error-input' : ''" placeholder="Select Hotel"
            @input="removeError('hotel_id')"></treeselect>
        </b-form-group>

        <b-form-group :label="$t('room_types.form.name_label')" label-for="name" :state="!hasError('name')"
          :invalid-feedback="getError('name')">
          <b-form-input id="name" v-model="formFields.name" :state="!hasError('name')" required
            @input="removeError('name')"></b-form-input>
        </b-form-group>

        <b-form-group label="Description" label-for="description" :state="!hasError('description')"
          :invalid-feedback="getError('description')">
          <b-form-textarea id="description" v-model="formFields.description" :state="!hasError('description')"
            @input="removeError('description')" rows="2"></b-form-textarea>
        </b-form-group>

        <b-form-group label="Bed Type" label-for="bed_type" :state="!hasError('bed_type')"
          :invalid-feedback="getError('bed_type')">
          <b-form-input id="bed_type" v-model="formFields.bed_type" :state="!hasError('bed_type')"
            @input="removeError('bed_type')"></b-form-input>
        </b-form-group>

        <b-form-group label="Capacity" label-for="capacity" :state="!hasError('capacity')"
          :invalid-feedback="getError('capacity')">
          <b-form-input id="capacity" type="number" v-model="formFields.capacity" :state="!hasError('capacity')"
            @input="removeError('capacity')"></b-form-input>
        </b-form-group>

        <!-- <b-form-group label="Total Rooms" label-for="total_rooms" :state="!hasError('total_rooms')"
          :invalid-feedback="getError('total_rooms')">
          <b-form-input id="total_rooms" type="number" v-model="formFields.total_rooms"
            :state="!hasError('total_rooms')" @input="removeError('total_rooms')"></b-form-input>
        </b-form-group> -->

        <b-form-group label="Base Price" label-for="base_price" :state="!hasError('base_price')"
          :invalid-feedback="getError('base_price')">
          <b-form-input id="base_price" type="number" step="0.01" v-model="formFields.base_price"
            :state="!hasError('base_price')" @input="removeError('base_price')"></b-form-input>
        </b-form-group>

        <!-- <b-form-group label="View" label-for="view" :state="!hasError('view')" :invalid-feedback="getError('view')">
          <b-form-input id="view" v-model="formFields.view" :state="!hasError('view')"
            @input="removeError('view')"></b-form-input>
        </b-form-group>

        <b-form-group label="Size (sqft)" label-for="size_sqft" :state="!hasError('size_sqft')"
          :invalid-feedback="getError('size_sqft')">
          <b-form-input id="size_sqft" type="number" v-model="formFields.size_sqft" :state="!hasError('size_sqft')"
            @input="removeError('size_sqft')"></b-form-input>
        </b-form-group> -->

        <b-form-group label="Facilities" label-for="facility_ids" :state="!hasError('facility_ids')"
          :invalid-feedback="getError('facility_ids')">
          <treeselect id="facility_ids" v-model="formFields.facility_ids" :options="facilityOptions" :normalizer="facilityNormalizer"
            :state="!hasError('facility_ids')" :class="hasError('facility_ids') ? 'error-input' : ''" 
            placeholder="Select Facilities" multiple @input="removeError('facility_ids')"></treeselect>
        </b-form-group>

        <b-form-group :label="$t('room_types.form.status_label')" label-for="is_active" :state="!hasError('is_active')"
          :invalid-feedback="getError('is_active')">
          <b-form-select id="is_active" v-model="formFields.is_active" :options="statusOptions"
            :state="!hasError('is_active')" required @input="removeError('is_active')"></b-form-select>
        </b-form-group>
        <b-form-group label="Room Images" label-for="room_images">
          <b-form-file id="room_images" ref="fileInput" multiple accept="image/*" @change="handleImageChange" />

          <div class="image-preview-wrapper mt-3 d-flex flex-wrap gap-2">
            <!-- Existing images from server -->
            <div v-for="(img, index) in existingImages" :key="'existing-' + img.id"
              class="preview-box position-relative">
              <img :src="img.path" class="preview-image" />
              <button type="button" class="remove-btn" @click="removeExistingImage(img, index)">
                &times;
              </button>
            </div>
            <!-- Newly selected images -->
            <div v-for="(img, index) in previewImages" :key="'new-' + index" class="preview-box position-relative">
              <img :src="img" class="preview-image" />
              <button type="button" class="remove-btn" @click="removeImage(index)">
                &times;
              </button>
            </div>
          </div>

        </b-form-group>

        <div class="d-flex gap-2 mt-4">
          <b-button type="submit" variant="primary" :disabled="isSubmitting">
            <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
            {{ isSubmitting ? $t('common.saving') : $t('common.save') }}
          </b-button>
          <b-button variant="secondary" @click="cancel">{{ $t('common.cancel') }}</b-button>
        </div>

        <div v-if="formLevelError" class="mt-3">
          <b-alert show variant="danger" class="mb-0">
            {{ formLevelError }}
          </b-alert>
        </div>
      </b-form>
    </b-card>

    <!-- Delete Image Confirmation Modal -->
    <b-modal v-model="showDeleteImageModal" :title="$t('common.delete_image')" @ok="confirmDeleteImage"
      ok-variant="danger" :ok-title="$t('common.delete')" :cancel-title="$t('common.cancel')">
      <p>{{ $t('room_types.delete_image_confirmation') }}</p>
      <div class="d-flex align-items-center">
        <img :src="imageToDelete.path" :alt="imageToDelete.name" class="image-to-delete me-3" />
        <div>
          <strong>{{ imageToDelete.name || 'Image' }}</strong>
          <br>
          <small class="text-muted">{{ $t('room_types.image_will_be_removed_on_save') }}</small>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import { request } from "@/Util/Request";
import NotifyMixin from "@/Util/NotifyMixin";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: "RoomTypeForm",
  mixins: [NotifyMixin],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    Treeselect,
  },
  data() {
    return {
      isSubmitting: false,
      validated: false,
      formErrors: {},
      formLevelError: "",
      images: [],
      previewImages: [],
      existingImages: [],
      removedImageIds: [],
      showDeleteImageModal: false,
      imageToDelete: {},
      imageToDeleteIndex: null,
      formFields: {
        hotel_id: null,
        name: "",
        description: "",
        bed_type: "",
        capacity: null,
        // total_rooms: null,
        base_price: null,
        // view: "",
        // size_sqft: null,
        is_active: 1,
        facility_ids: [],
      },
      statusOptions: [
        { value: 1, text: this.$t("room_types.status_active") },
        { value: 0, text: this.$t("room_types.status_inactive") },
      ],
      hotelOptions: [],
      facilityOptions: [],
    };
  },
  computed: {
    isEdit() {
      return !!this.id;
    },
  },
  methods: {
    handleImageChange(event) {
      const files = Array.from(event.target.files);
      this.images = files;
      this.previewImages = files.map((file) => URL.createObjectURL(file));
    },

    removeImage(index) {
      this.previewImages.splice(index, 1);
      this.images.splice(index, 1);

      const dataTransfer = new DataTransfer();
      this.images.forEach(file => dataTransfer.items.add(file));
      this.$refs.fileInput.$el.files = dataTransfer.files;
    },

    removeExistingImage(img, index) {
      this.imageToDelete = img;
      this.imageToDeleteIndex = index;
      this.showDeleteImageModal = true;
    },

    confirmDeleteImage() {
      this.removedImageIds.push(this.imageToDelete.id);
      this.existingImages.splice(this.imageToDeleteIndex, 1);

      this.imageToDelete = {};
      this.imageToDeleteIndex = null;

      this.$bvToast.toast(this.$t('room_types.image_marked_for_deletion'), {
        title: this.$t('common.success'),
        variant: 'success',
        solid: true,
      });
    },

    normalizer(option) {
      return {
        id: option.id,
        label: option.name,
      };
    },
    facilityNormalizer(option) {
      return {
        id: option.id,
        label: option.name,
      };
    },
    hasError(field) {
      return !!this.formErrors[field];
    },
    getError(field) {
      return this.formErrors[field] ? this.formErrors[field][0] : "";
    },
    removeError(field) {
      if (this.formErrors[field]) {
        delete this.formErrors[field];
      }
      this.formLevelError = "";
    },
    async fetchRoomType() {
      try {
        const response = await request({
          method: "get",
          url: `/room-types/${this.id}`,
        });
        this.formFields = {
          ...this.formFields,
          ...response.data,
          hotel_id: response.data.hotel ? response.data.hotel.id : null,
          facility_ids: response.data.amenities ? response.data.amenities.map(amenity => amenity.facility_id) : [],
        };
        this.existingImages = response.data.attachments || [];
      } catch (error) {
        this.formLevelError = error.response?.data?.message || this.$t("room_types.fetch_error");
        this.notifyError(this.formLevelError);
        this.$router.push("/admin/room-types");
      }
    },
    async handleSubmit() {
      try {
        this.validated = true;
        this.isSubmitting = true;
        this.formErrors = {};
        this.formLevelError = "";

        if (!this.formFields.name.trim()) {
          this.formErrors.name = [this.$t("room_types.validation.name_required")];
        }
        if (!this.formFields.hotel_id) {
          this.formErrors.hotel_id = [this.$t("room_types.validation.hotel_required")];
        }
        if (this.formFields.capacity === null || this.formFields.capacity < 1) {
          this.formErrors.capacity = [this.$t("room_types.validation.capacity_min")];
        }
        // if (this.formFields.total_rooms === null || this.formFields.total_rooms < 1) {
        //   this.formErrors.total_rooms = [this.$t("room_types.validation.total_rooms_min")];
        // }
        if (this.formFields.base_price === null || this.formFields.base_price < 0) {
          this.formErrors.base_price = [this.$t("room_types.validation.base_price_min")];
        }
        // if (this.formFields.size_sqft !== null && this.formFields.size_sqft < 0) {
        //   this.formErrors.size_sqft = [this.$t("room_types.validation.size_sqft_min")];
        // }
        if (Object.keys(this.formErrors).length > 0) {
          throw new Error("Validation failed");
        }

        const formData = new FormData();

        for (const key in this.formFields) {
          if (this.formFields[key] !== null && this.formFields[key] !== undefined && this.formFields[key] !== '') {
            if (key === 'facility_ids' && Array.isArray(this.formFields[key])) {
              // Handle array of facility IDs
              this.formFields[key].forEach(facilityId => {
                formData.append('facility_ids[]', facilityId);
              });
            } else {
              formData.append(key, this.formFields[key]);
            }
          }
        }

        this.images.forEach((file) => {
          formData.append(`attachments[]`, file);
        });

        this.removedImageIds.forEach((id) => {
          formData.append(`removed_attachments[]`, id);
        });

        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }

        await request({
          method: this.isEdit ? "post" : "post",
          url: this.isEdit ? `/room-types/${this.id}` : "/room-types",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.$bvToast.toast(
          this.$t(this.id ? "room_types.update_success" : "room_types.create_success"),
          {
            title: this.$t('common.success'),
            variant: 'success',
            solid: true,
          }
        );

        this.removedImageIds = [];

        this.$router.push("/admin/room-types");
      } catch (error) {
        if (error.status === 422) {
          this.formErrors = error.data.message || {};
          this.formLevelError = this.formErrors;
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    cancel() {
      this.removedImageIds = [];
      this.imageToDelete = {};
      this.imageToDeleteIndex = null;
      this.showDeleteImageModal = false;
      this.$router.push("/admin/room-types");
    },
    async fetchHotels() {
      try {
        const response = await request({ method: "get", url: "/hotels" });
        this.hotelOptions = response.data || [];
      } catch (e) {
        this.hotelOptions = [];
      }
    },
    async fetchFacilities() {
      try {
        const response = await request({ method: "get", url: "/facilities" });
        this.facilityOptions = response.data || [];
      } catch (e) {
        this.facilityOptions = [];
      }
    },
  },
  created() {
    this.fetchHotels();
    this.fetchFacilities();
    if (this.isEdit) {
      this.fetchRoomType();
    }
  },
};
</script>

<style scoped>
.room-type-form {
  padding: 20px;
}

.image-preview-wrapper {
  gap: 10px;
  display: flex;
  flex-wrap: wrap;
}

.remove-btn {
  position: absolute;
  top: -6px;
  right: -6px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 16px;
  line-height: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-box {
  width: 100px;
  height: 100px;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-to-delete {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #e9ecef;
}
</style>